"use strict";

module.exports = require("./createContainer");


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/dist/node/lib/createContainer/index.js
 ** module id = 466
 ** module chunks = 0
 **/